import React from 'react';
import { Block, BLOCKS, INLINES, Inline } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import { Flexbox } from '../Flexbox';
import { Column } from '../Layout';
import { Text } from '../Text';
import RichText from '../RichText';
import { EmbeddedInlineEntryNode } from '../RichText/Nodes';

import {
  InlineAnchor,
  DesktopPolicyWrapper,
  CaptionWithLineBreaks
} from './styles';

type DesktopPolicyDisclaimerFields = Pick<
  IFullwidthHero20Fields,
  'desktopImageDisclaimer'
>;

interface DesktopPolicyDisclaimerProps extends DesktopPolicyDisclaimerFields {
  alignContentToLeft?: boolean;
  noMargin?: boolean;
}

export default function DesktopImageDisclaimer({
  desktopImageDisclaimer,
  noMargin = false
}: DesktopPolicyDisclaimerProps) {
  const RICH_TEXT_OVERRIDE: RenderNode = {
    [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
      return (
        <CaptionWithLineBreaks
          as="p"
          fontSize={{
            0: '2xs',
            tablet: 's'
          }}
          fontWeight="400"
          colour="defaultText"
          textAlign="center"
        >
          {children}
        </CaptionWithLineBreaks>
      );
    },
    [BLOCKS.HEADING_6]: (_node: Block | Inline, children) => (
      <Text
        as="p"
        fontSize={{
          0: 'h6_0',
          tablet: 'h6_tablet'
        }}
        fontWeight="500"
        marginBottom="m"
        textAlign={{
          tablet: 'left'
        }}
      >
        {children}
      </Text>
    ),
    [INLINES.HYPERLINK]: (node, children) => (
      <InlineAnchor
        href={node.data.uri}
        colour="defaultText"
        hoverColor="inlineAnchor"
      >
        {children}
      </InlineAnchor>
    ),
    [INLINES.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedInlineEntryNode node={node} colour="defaultText" fontWeight="p">
        {children}
      </EmbeddedInlineEntryNode>
    )
  };

  return (
    <Column size={12} justifyContent="center" margin={{ 0: 'auto', tablet: 0 }}>
      <Flexbox
        flexDirection="row"
        justifyContent="space-between"
        margin={{ 0: noMargin ? 0 : 'auto', tablet: 0 }}
        alignItems="center"
      >
        <DesktopPolicyWrapper>
          <RichText
            data={desktopImageDisclaimer}
            overrideOptions={RICH_TEXT_OVERRIDE}
          />
        </DesktopPolicyWrapper>
      </Flexbox>
    </Column>
  );
}
